/* Shopify can cache Liquid's `now`. Recheck in the browser and at the boundary.
   Templates are inert: only the selected hero's images and heading are active. */
(() => {
  if (customElements.get('ps-saison')) return;
  class PsSaison extends HTMLElement {
    connectedCallback() {
      this.check = this.check.bind(this);
      this.check();
      document.addEventListener('visibilitychange', this.check);
      window.addEventListener('pageshow', this.check);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.check);
      window.removeEventListener('pageshow', this.check);
    }
    check() {
      clearTimeout(this.timer);
      const start = Number(this.dataset.start);
      const end = Number(this.dataset.ende);
      const now = Date.now();
      const enabled = this.dataset.enabled === 'true' && start > 0 && end > start;
      const active = enabled && now >= start && now < end;
      if (String(active) !== this.dataset.active) {
        const current = this.querySelector('[data-saison-inhalt]');
        const alternative = this.querySelector('[data-saison-alternative]');
        const previous = document.createDocumentFragment();
        const hadFocus = current.contains(document.activeElement);
        while (current.firstChild) previous.append(current.firstChild);
        current.append(alternative.content);
        alternative.content.append(previous);
        this.dataset.active = String(active);
        if (hadFocus) current.querySelector('a, button, summary')?.focus();
        document.dispatchEvent(new CustomEvent('ps:saison:wechsel'));
      }
      const next = enabled && now < start ? start : enabled && now < end ? end : null;
      // Stay below the browser's 32-bit timeout limit. Hidden tabs recheck on return.
      if (next !== null) this.timer = setTimeout(this.check, Math.min(next - now + 50, 86400000));
    }
  }
  customElements.define('ps-saison', PsSaison);
})();
